import { render, staticRenderFns } from "./animalAge.vue?vue&type=template&id=8e591d42"
import script from "./animalAge.vue?vue&type=script&lang=js"
export * from "./animalAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports